import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../ApiConfig';
import style from '../../../css/admin/Workshopupload.module.css';
import { motion, AnimatePresence } from 'framer-motion';
import { showCustomAlerterror } from '../../customalert';
import { getSecureToken } from '../../ApisService/apiService';

const Communitydata = () => {
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    fetchUploads();
  }, []);
  const fetchUploads = async () => {
    const { secrettoken, ts } = await getSecureToken();
    try {
      const response = await axios.get(`${API_BASE_URL}/Community/get_community.php`, {
                    headers: {
            'X-TOKEN': secrettoken,
            'X-TIMESTAMP': ts,
          },
        withCredentials: true,
      });
      setUploads(response.data);
    } catch (err) {
      setError('Failed to load community uploads.');
      showCustomAlerterror('Failed to load community uploads.');
    } finally {
      setLoading(false);
    }
  };

  const deleteUpload = async (id) => {
    if (!window.confirm("Are you sure you want to delete this upload?")) return;
    const { secrettoken, ts } = await getSecureToken();
    try {
      await axios.post(`${API_BASE_URL}/Community/delete_community.php`, { id }, {
                    headers: {
            'X-TOKEN': secrettoken,
            'X-TIMESTAMP': ts,
          },
        withCredentials: true,
      });
      setUploads(uploads.filter(upload => upload.id !== id)); // Update UI
    } catch (error) {
      console.error("Error deleting upload:", error);
    }
  };


  return (
    <div className={style.uploadContainercommunity}>
      {/* <h2>Community Uploads</h2> */}
      {loading && <p>Loading...</p>}
      {error && <p className={style.error}>{error}</p>}
      {!loading && !error && uploads.length === 0 && <p>No uploads available.</p>}
      <div className={style.uploadList}>
        {uploads.map((upload) => (
          <div key={upload.id} className={style.uploadCard}>
            <h3>{upload.title}</h3>
            <p>{upload.description}</p>
            <div className={style.imageContainer}>
              {JSON.parse(upload.images).map((image, index) => (
                <img
                  key={index}
                  src={`${API_BASE_URL}Community/community_uploads/images/${image}`}
                  alt={upload.title}
                  style={{ width: "200px", cursor: "pointer" }}
                  onClick={() => setSelectedImage(`${API_BASE_URL}Community/community_uploads/images/${image}`)}
                />
              ))}
            </div>
            <div className={style.documentContainer}>
              {/* <h4>Documents:</h4> */}
              {JSON.parse(upload.documents).map((doc, index) => (
                <a key={index} className={style.documentLink} href={`${API_BASE_URL}Community/community_uploads/documents/${doc}`} target="_blank" rel="noopener noreferrer">
                  📄 {doc}
                </a>
              ))}
            </div>
            <div className={style.uploadContainer}>

              <button className={style.deleteButton} onClick={() => deleteUpload(upload.id)}>❌ Delete</button>
            </div>
          </div>
        ))}
      </div>

      {/* Image Modal */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className={style.overlay}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
          >
            <motion.div
              className={style.modal}
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              onClick={(e) => e.stopPropagation()}
            >
              <img src={selectedImage} alt="Preview" />

              <button className={style.closeButton} onClick={() => setSelectedImage(null)}>✖ Close</button>


            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Communitydata;
